// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ChevronUp = function ChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.836 14.415 10 7.575l-6.832 6.84c-.4.4-1 .332-1.332 0a.95.95 0 0 1 .001-1.324l7.499-7.506a.94.94 0 0 1 1.326 0l7.504 7.506c.339.34.398.925 0 1.324a.95.95 0 0 1-1.329 0"
  }));
};
